// Dynamic-node export strings: GFM tables, bracket placeholders, etc.

export function escapeMarkdownTableCell(text: string): string {
  return text.replace(/\r?\n/g, ' ').replace(/\|/g, '\\|').trim();
}

export function markdownTableRow(cells: readonly string[]): string {
  return `| ${cells.map((c) => escapeMarkdownTableCell(c)).join(' | ')} |`;
}

export function markdownTable(
  headers: readonly string[],
  rows: readonly (readonly string[])[]
): string {
  if (headers.length === 0) {
    return '';
  }
  const n = headers.length;
  const headerLine = markdownTableRow(headers);
  const sepLine = `| ${Array.from({length: n}, () => '---').join(' | ')} |`;
  const bodyLines = rows.map((row) => {
    const cells: string[] = [...row];
    while (cells.length < n) {
      cells.push('');
    }
    return markdownTableRow(cells.slice(0, n));
  });
  return [headerLine, sepLine, ...bodyLines].join('\n');
}

export function markdownBracketReference(label: string, payload: string): string {
  return `[${label}: ${payload}]`;
}
